import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Contains the selectors that select state from the 'UAPayments' store object.
 *
 * @export
 * @namespace PaymentsSelectors
 */

var selectors = function selectors() {
  _classCallCheck(this, selectors);
};

_defineProperty(selectors, "moduleIdentifier", 'UAPayments');

_defineProperty(selectors, "selectData", function (state) {
  return state[selectors.moduleIdentifier].data.payload;
});

_defineProperty(selectors, "isProcessing", function (state) {
  return state[selectors.moduleIdentifier].isProcessing.payload;
});

_defineProperty(selectors, "selectError", function (state) {
  return state[selectors.moduleIdentifier].error.payload;
});

_defineProperty(selectors, "sortedByDateSelector", function (leftPayment, rightPayment) {
  return leftPayment.paymentDate > rightPayment.paymentDate ? -1 : 1;
});

_defineProperty(selectors, "findSpecificPayment", function (payments, paymentId) {
  return _findInstanceProperty(payments).call(payments, function (payment) {
    return payment.paymentId === paymentId;
  });
});

_defineProperty(selectors, "benefitsReducerSelector", function (partial, current) {
  var _context;

  var accumulated = partial;
  var next = current;

  var existingIndex = _indexOfInstanceProperty(_context = _mapInstanceProperty(accumulated).call(accumulated, function (benefit) {
    return benefit.caseId;
  })).call(_context, next.caseId);

  if (existingIndex < 0) {
    next.groupedDetails = [];
    next.groupedDetails.push(current);
    accumulated.push(next);
  } else {
    accumulated[existingIndex].groupedDetails.push(current);
  }

  return accumulated;
});

_defineProperty(selectors, "paymentsReducerSelector", function (partial, current) {
  if (partial.length > 0 && current.paymentDate.getYear() === partial[partial.length - 1][0].paymentDate.getYear()) {
    partial[partial.length - 1].push(current);
  } else {
    partial.push([current]);
  }

  return partial;
});

export { selectors as default };